export default __webpack_public_path__ + "static/media/cups-es.81216c38.png";